//import liraries
import React, { useEffect } from 'react';
import { View, Text, ScrollView, FlatList } from 'react-native';
import { getCleanUrl, isWeb } from '../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import CustomSvg from '../../components/customSvg/customSvg';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { guestJourneyNotification } from '../../Redux/Actions/gjNotificationAction';
import CustomPressable from '../../components/customPressable/customPressable';
import moment from 'moment';
import { NOTIFICATION_DETAIL } from '../../navigation/StackNavigator/routes';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import CustomFlatList from '../../components/customFlatList';
import { CHEVRON_RIGHT, NOMESSAGE_ICON } from '../../assets';
import Header from '../../components/Header/Header';
import { useNavigation } from '@react-navigation/native';

const Notification = props => {
  const { hideBackButton } = props || {};

  const navigation = useNavigation();

  const { currentLayout } = useSelector(state => state.deviceConfigSlice);

  const { notifications, newMessagesCount } = useSelector(state => state.notificationSlice);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const getStyles = useCssStyle();



  const handleGoBack = () => {
    dispatch(setGoHome(true));
  }

  useEffect(() => {
    dispatch(guestJourneyNotification());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderItem = ({ item }) => {
    const isNew = item.status === 'NEW';

    return (
      <CustomPressable id={`list_itemContainer notification_itemContainer`} style={getStyles(['list_itemContainer', 'notification_itemContainer'])} onPress={() => navigation.navigate(NOTIFICATION_DETAIL, { item })}>

        <View id={`notificationdot_container`}  style={getStyles(["notificationdot_container"])}>
          <View id='notificationDot notificationDot_placeholder' style={getStyles([ isNew ? 'notificationDot' : "notificationDot_placeholder"])}></View>
        </View>

        <View id='list_itemContainer_textContainer notification_itemContainer_textContainer' style={getStyles(['list_itemContainer_textContainer', 'notification_itemContainer_textContainer'])}>
          {item?.sender && <Text id='list_itemContainer_textContainer_title notification_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer_title', 'notification_itemContainer_textContainer_title'])}>{item.sender}</Text>}
          {item?.messageText && <Text id='list_itemContainer_textContainer_subtitle notification_itemContainer_textContainer_subtitle' style={getStyles(['list_itemContainer_textContainer_subtitle', 'notification_itemContainer_textContainer_subtitle'])} numberOfLines={1} ellipsizeMode="tail">{item.messageText}</Text>}
          {item?.dateCreated && <Text id='list_itemContainer_textContainer_subtitle notification_itemContainer_textContainer_subtitle' style={getStyles(['list_itemContainer_textContainer_subtitle', 'notification_itemContainer_textContainer_subtitle'])} numberOfLines={1} ellipsizeMode="tail">{moment(item.dateCreated).format('MMM DD')}</Text>}
        </View>

        <View id='list_itemContainer_arrow notification_itemContainer_arrow' style={getStyles(['list_itemContainer_arrow', 'notification_itemContainer_arrow'])}>
          <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
        </View>

      </CustomPressable>
    );
  };


  const renderHeader = () => {

    return (
      <View id='widgetmainContainerHeaderContainer notificationsHeaderContainer' style={getStyles(['widgetmainContainerHeaderContainer', 'notificationsHeaderContainer'])}>
        {
          currentLayout?.brandingInfo?.launcherBgImageUrl &&
          <ImageComp id='widgetmainContainerHeaderImg notificationsHeaderImg' source={getCleanUrl(currentLayout?.brandingInfo?.launcherBgImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'notificationsHeaderImg'])} />
        }
        <View id='widgetmainContainerHeaderTitleContainer notificationsHeaderTitleContainer' style={getStyles(['widgetmainContainerHeaderTitleContainer', 'notificationsHeaderTitleContainer'])}>
          <Text id='widgetmainContainerHeaderTitle notificationsHeaderTitle' style={getStyles(['widgetmainContainerHeaderTitle', 'notificationsHeaderTitle'])}>{t('notification.heading')}</Text>
          <Text id='widgetmainContainerHeaderSubTitle notificationsHeaderSubTitle' style={getStyles(['widgetmainContainerHeaderSubTitle', 'notificationsHeaderSubTitle'])}>{t('notification.sub_heading')}</Text>
        </View>
      </View>
    )
  }

  return (
    <View id='widgetRootContainer notificationsRootContainer' style={getStyles(['widgetRootContainer', 'notificationsRootContainer'])}>
      {hideBackButton ? <Header /> : <HeaderWithBack handleCustomBackPress={handleGoBack} />}

      <ScrollView id='widgetmainContainer notificationsMainContainer' contentContainerStyle={getStyles(['widgetmainContainer', 'notificationsMainContainer'])} showsVerticalScrollIndicator={false}>
        {renderHeader()}


        <View id='widgetmainContainerChildContainer notificationsMainContainerChildContainer' style={getStyles(['widgetmainContainerChildContainer', 'notificationsMainContainerChildContainer'])}>
          {notifications?.length > 0 ? (
            <CustomFlatList
              data={notifications}
              renderItem={renderItem}
              keyExtractor={item => item.id.toString()}
              showsVerticalScrollIndicator={false}
            />
          ) : (
            <View id='noMessageContainer' style={getStyles(['noMessageContainer'])}>
              <ImageComp id='noMessageContainer_img' source={NOMESSAGE_ICON} style={getStyles(['noMessageContainer_img'])} />
              <Text id='noMessageContainer_text' style={getStyles(['noMessageContainer_text'])}>{t('notification.no_message')}</Text>
            </View>
          )}
        </View>
      </ScrollView>
    </View>
  );
};

export default React.memo(Notification);
